export default {
  clock: '{sign}{hours}:{minutes}',
  timezone: '(GMT {offset}) {timezone}',
  salaryRange: '{low}k € - {high}k €',
  salaryValue: '{value}k €',
  salaryLessThan: '< {}k €',
  salaryMoreThan: '{}k € +',
}
